import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import "../App.css";

const ConfirmationPopup = ({ booking, onClose }) => {
  const { horse, date, time, name, image } = booking;

  return (
    <motion.div
      className="confirmation-popup"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, type: "spring", stiffness: 100 }}
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <motion.div
        className="confirmation-popup-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.5 }}
      >
        <h2>Booking Confirmed!</h2>
        <p>Thank you, {name}!</p>
        <p>You have successfully booked a ride with {horse}.</p>
        <p>Date: {date.toLocaleDateString()}</p>
        <p>Time: {time}</p>
        <button onClick={onClose}>Close</button>
      </motion.div>
    </motion.div>
  );
};

ConfirmationPopup.propTypes = {
  booking: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmationPopup;